<template>
  <slot name="no-results" :searchQuery="searchQuery">
    <div class="no-results">
      <IconSearch v-if="!searchQuery" :stroke-width="1.5" class="no-results-icon" />
      <IconZoomExclamation v-else :stroke-width="1.5" class="no-results-icon" />
      <p>{{ resolvedMessage }}</p>
    </div>
  </slot>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { IconZoomExclamation, IconSearch } from '@tabler/icons-vue';
import translator from '@/locale/translator';

const props = withDefaults(
  defineProps<{
    message?: string;
    searchQuery?: string;
  }>(),
  {
    searchQuery: '',
  }
);

const resolvedMessage = computed(() => {
  if (props.message) return props.message;
  return props.searchQuery ? translator.get('nothing_found') : translator.get('type_to_search');
});
</script>

<style scoped>
.no-results {
  padding: 40px 12px;
  text-align: center;
  color: #9ca3af;
}

.no-results-icon {
  padding: 0;
  width: 24px;
  height: 24px;
  opacity: 0.5;
}

.no-results p {
  margin-top: 4px;
  margin-bottom: 0;
  font-size: 11px;
  line-height: 24px;
  font-weight: 400;
}
</style>
